<script setup lang="ts">
import { useDataStore } from '@/stores/useDataStore';
import { initializeDates } from '@/functions/historical_data';
import { useHistorycalStore } from '@/stores/useHistorycalStore';
import HistoricalData_chart from '@/components/HistoricalData/HistoricalData_chart.vue';
import HistoricalData_chartAllData from '@/components/HistoricalData/HistoricalData_chartAllData.vue';
import HistoricalData_dataList from '@/components/HistoricalData/HistoricalData_dataList.vue';
import { onMounted, watch } from 'vue';
import HistoricalData_chartOutliers from '@/components/HistoricalData/HistoricalData_chartOutliers.vue';

const dataStore = useDataStore();
const historyStore = useHistorycalStore();

const resetDates = () => {
    initializeDates();
    if (dataStore.selectedCulture?.pbr?.numero_pbr) {
        historyStore.fetchHistoricalData();
    }
};

// Initialiser et surveiller les changements
onMounted(() => {
    initializeDates();
    if (dataStore.selectedCulture?.pbr?.numero_pbr) {
        historyStore.fetchHistoricalData();
    }
});

// Surveiller les changements de selectedCulture
watch(() => dataStore.selectedCulture, (newCulture) => {
    initializeDates();
    if (newCulture?.pbr?.numero_pbr) {
        historyStore.fetchHistoricalData();
    }
});

// Surveiller les changements de startDate et endDate
watch([() => historyStore.startDate, () => historyStore.endDate], ([newStartDate, newEndDate]) => {
    if (newStartDate && newEndDate && dataStore.selectedCulture?.pbr?.numero_pbr) {
        historyStore.fetchHistoricalData();
    }
});
</script>

<template>
    <div v-if="dataStore.selectedCulture?.pbr?.numero_pbr?.startsWith('B')" class="module">
        <h2>{{ $t('historicalData') }} {{ dataStore.selectedCulture.pbr.numero_pbr }}</h2>
        <div class="controls">
            <div class="date-picker">
                <label>
                    {{ $t('startDate') }}
                    <input v-model="historyStore.startDate" type="datetime-local" />
                </label>
                <label>
                    {{ $t('endDate') }}
                    <input v-model="historyStore.endDate" type="datetime-local" />
                </label>
                <button class="custom-btn" style="margin-top: 10px;" @click="resetDates">
                    🔙
                </button>
            </div>
        </div>
        <div v-if="historyStore.selectedMetrics.includes('temperature')">
            <label>Température Min: {{ historyStore.temperatureMin }} °C</label>
            <input v-model.number="historyStore.temperatureMin" type="range" min="0" max="50" step="0.1" />
        </div>
        <div v-if="historyStore.selectedMetrics.includes('temperature')">
            <label>Température Max: {{ historyStore.temperatureMax }} °C</label>
            <input v-model.number="historyStore.temperatureMax" type="range" min="0" max="50" step="0.1" />
        </div>

        <!-- Curseurs pour le pH -->
        <div v-if="historyStore.selectedMetrics.includes('ph')">
            <label>pH Min: {{ historyStore.phMin }}</label>
            <input v-model.number="historyStore.phMin" type="range" min="0" max="14" step="0.1" />
        </div>
        <div v-if="historyStore.selectedMetrics.includes('ph')">
            <label>pH Max: {{ historyStore.phMax }}</label>
            <input v-model.number="historyStore.phMax" type="range" min="0" max="14" step="0.1" />
        </div>
        <div v-if="historyStore.error" class="error">{{ historyStore.error }}</div>
        <div>
            <HistoricalData_chart />
            <HistoricalData_chartAllData />
            <HistoricalData_chartOutliers />
            <HistoricalData_dataList />
        </div>
    </div>
</template>